import Image from 'next/image'
import Link from 'next/link'

import type { Car, Media, CarCardBlock as TCarCardBlock } from '@/payload-types'
import { getMediaUrl } from '@/payload/utils/getMediaUrl'

export const CarCardBlock = ({ promoCars }: TCarCardBlock) => {
  return (
    <div className="mt-[max(1rem,calc(100dvh-60rem))] items-center justify-self-center justify-center flex flex-col md:flex-row gap-4 md:gap-12">
      {(promoCars as Car[])?.map((car: Car) => {
        const image = car.featuredImage as Media
        const imgSrc = getMediaUrl(image.filename)

        return (
          <Link
            key={car.id}
            href={`/vozila/${car.relativeUrl}`}
            prefetch
            className="aspect-4/3"
          >
            <Image
              src={imgSrc}
              alt={image.alt}
              className="w-[min(60dvw,20dvh)] md:w-[min(15dvw,45dvh)] rounded-xl hover:scale-105 transition-transform duration-500"
              width={400}
              height={300}
              quality={75}
              sizes="(max-width: 768px) 288px, 20vw"
              priority
              fetchPriority="high"
              placeholder="blur"
              blurDataURL={image.blurDataURL as string | undefined}
            />
          </Link>
        )
      })}
    </div>
  )
}
